export const getJobsPostingsRoute = '/employer/job-postings/get';
export const updateJobsPostingsRoute = '/employer/job-postings/update/';
export const addJobsPostingsRoute = '/employer/job-postings/add/';
